/* tslint:disable */
/* eslint-disable */
/**
 * AGAIN-AGAIN API
 * backend api for tracking container movement for again-again
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NFCTag,
    NFCTagFromJSON,
    NFCTagFromJSONTyped,
    NFCTagToJSON,
} from './';

/**
 * 
 * @export
 * @interface IssueContainer
 */
export interface IssueContainer {
    /**
     * 
     * @type {string}
     * @memberof IssueContainer
     */
    containerTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof IssueContainer
     */
    appliedPromotionId: string | null;
    /**
     * 
     * @type {NFCTag}
     * @memberof IssueContainer
     */
    tag: NFCTag;
}

export function IssueContainerFromJSON(json: any): IssueContainer {
    return IssueContainerFromJSONTyped(json, false);
}

export function IssueContainerFromJSONTyped(json: any, ignoreDiscriminator: boolean): IssueContainer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'containerTypeId': json['container_type_id'],
        'appliedPromotionId': json['applied_promotion_id'],
        'tag': NFCTagFromJSON(json['tag']),
    };
}

export function IssueContainerToJSON(value?: IssueContainer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'container_type_id': value.containerTypeId,
        'applied_promotion_id': value.appliedPromotionId,
        'tag': NFCTagToJSON(value.tag),
    };
}


